<template>
  <div class="alert-window" v-if="alertState.isVisible">
    <div class="alert-content">
      <div class="alert-content-box">
        <h3>{{ t(alertState.title) }}</h3>
        <p v-html="t(alertState.message)"></p>
      </div>
      <div class="btn">
        <button @click="confirmAlert" :class="alertState.type === AlertType.ALERT ? 'full-button' : 'half-button'">
          {{ t('common.alert_key001') }}
        </button>
        <button v-if="alertState.type === AlertType.CONFIRM" @click="cancelAlert" class="half-button">
          {{ t('common.alert_key002') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { alertState, confirmAlert, cancelAlert, AlertType } from '@/utils/alertController.js';

const { t } = useI18n();

// 鎖定 body 滾動狀態
watch(
  () => alertState.isVisible,
  (visible) => {
    document.body.style.overflow = visible ? 'hidden' : '';
  },
);
</script>

<style scoped>
.alert-window {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.alert-content {
  min-width: 300px;
  max-width: 400px;
  background: rgba(25, 25, 25, 0.8);
  border: 0.25px solid hsla(0, 0%, 100%, 0.6);
  box-shadow: 0 0 4px 0 rgba(103, 55, 140, 0.7);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  text-align: center;
  @media (max-width: 576px) {
    max-width: 90%;
  }
}
.alert-content-box {
  padding: 20px 30px;
}
.alert-content h3 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
}
.alert-content-box p {
  white-space: pre-line;
}
.alert-content .btn {
  display: flex;
}
.alert-content-box .a-link {
  color: #e79fff;
  text-decoration: underline;
}
.full-button {
  flex-basis: 100%;
}
.half-button {
  flex-basis: 50%;
}
.alert-window button {
  background: rgba(103, 55, 140, 0.2);
  border-top: 0.25px solid hsla(0, 0%, 100%, 0.6);
  margin-top: 20px;
  padding: 10px 20px;

  &.half-button:first-child {
    border-right: 0.25px solid hsla(0, 0%, 100%, 0.6);
  }
}
.alert-window button:hover {
  background: rgba(103, 55, 140, 0.5);
}
</style>
